import React, { FC } from 'react';
import { TwButton, TwButtonType } from '../../../components/TwButtons/TwButtons';
import TwDialog from '../../../components/TwDialog/TwDialog';
import { ReactComponent as WarningSign } from '../../../assets/warning-sign.svg';
import { Typography, Box, styled } from '@mui/material';

interface MergeTripsConfirmationProps {
  open: boolean;
  onClose: () => void;
  onMerge: () => void;
}

export const Message = styled(Typography)({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '24px',
  color: '#6B7280'
});

const MergeTripsConfirmation: FC<MergeTripsConfirmationProps> = ({ open, onClose, onMerge }) => {
  return (
    <TwDialog
      open={open}
      onClickClose={onClose}
      size="sm"
      title="Confirm trip merge"
      actions={[
        <TwButton
          key="2"
          fullwidth={false}
          type={TwButtonType.secondary}
          label="Cancel"
          action={onClose}
        />,
        <TwButton
          key="1"
          fullwidth={false}
          type={TwButtonType.negative}
          label="Merge trips"
          action={onMerge}
        />
      ]}
      fullWidthAction
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{ paddingTop: '20px' }}
      >
        <WarningSign />
        <Box paddingTop={'20px'}>
          <Message paragraph>
            You are about to merge trips. This action will consolidate the trips into one,
            preserving the dispatch information (driver, truck, and trailer) from the first trip
            only (or the trip you are merging into).{' '}
            <span
              style={{
                fontWeight: '600'
              }}
            >
              Please note:
            </span>{' '}
            Any dispatch information assigned to other trips will be lost.{' '}
          </Message>
          <Message paragraph>
            Are you sure you want to proceed with the merge? This action cannot be undone.
          </Message>
        </Box>
      </Box>
    </TwDialog>
  );
};

export default MergeTripsConfirmation;
